// extracted by mini-css-extract-plugin
export default {"root":"Tab_root__91mEP"};